import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { AuthService } from '@fry/lib/auth';
import { SecurityService } from '@fry/lib/security';

const baseMenu = [
  {
    id: 'roles',
    link: '/roles',
    title: $localize `Roles`,
    parent: 'user-management'
  }
];

@Injectable()
export class RolesMenu extends BaseMenuService {

    constructor(auth: AuthService, security: SecurityService) {
        super(auth, security);
    }

    cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            of([{
              id: 'user-management',
              title: $localize `User management`
            }]),
            this.menuWithPermission(baseMenu, 'roles.view')
        );
    }
}
